var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "url(#pattern0_29598_14376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_29598_14376",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_29598_14376",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_29598_14376",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACPklEQVR4nO3dvYrUUByG8VjozayKYCVaiHbiBXgPdorYCDOdIihYiKWKH421na2l3oEgqxZ+NJZ+wCMHZ4uFuGYmyZvNnufpZ+fkt2cy/81smKYxMzMzMzOz/RtwAngCfAJ+Ah+BR8DRqdd2YAKuAr9p7xdweeo1zj5gSbduTL3WGpB3EjuALHYQWewgsthBZLGDyDs5+oWgy5y9tevJao/xsB9OfWy1YG9PfVy1YP+Y+phqwf4w9fHUgv24qRBuucFj+lSu+h1vaondYEnsK00t0Q51a82fcX0D5EVTS+y9G8fEFjmALXIAW+QAtsgBbJHXbJPRb63HzDqG/ZN5rZ1dTYxzxU3s0DVksUPIYgeR68Ymi1wnNtMgl5yTA4kcSORAIgcSOZDIgUQOJHIgkQOJHEjkQCIHEjmQyIFEDiRyIJFFHjA/GQkkciDgMHASOA9cKzfOJM4V1PRvWm0Bp0TO7fBy2647eeyAbyMpL0Zf/JwC3okcCHgzMPQyse7ZBbwaEHkx9fHs24AXIgcC7gwAvUysddYB50TuGXCsy24DzgK3gWfAS+A18HY1kew1/rmTV4A3hwABtoDvIrfjHALeD7X7gLvu5HaYM0O+1IFLni7aYR4MeVsCf6/4OSe3XCz6OuSbGHBkk1/QgQ642GFkq+uGmzECnneAFrtvwJeO0GL3afUlA/9rG7hXPtrq9WQ1V86//8Atb5D3gdNlzp56nbOvTAgr7LKzPwNPgQtlGpl6bWZmZmZmZtb06w8+ceqv9e1skAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.878b540ad43c24c85d68ecb60d9ba65c.svg";
export { ForwardRef as ReactComponent };